import { defineStore } from 'pinia';
import { useScopeStore } from '@/stores/scopeStore.ts';
import { ref } from 'vue';

type ElectricalComponentSelection = number | string;

export const useElectricalComponentStore = defineStore('electricalComponent', () => {
    const electricalComponent = ref<ElectricalComponentSelection | null>(null);

    const scopeStore = useScopeStore();

    function setElectricalComponent(value: ElectricalComponentSelection | null) {
        electricalComponent.value = value;
    }

    function getSelectedScope() {
        return scopeStore.getSelectedScope();
    }

    function updateSelectedScope(scope: string | null) {
        scopeStore.updateSelectedScope(scope);
    }

    return {
        electricalComponent,
        setElectricalComponent,
        getSelectedScope,
        updateSelectedScope
    };
});

export type ElectricalComponentStore = ReturnType<typeof useElectricalComponentStore>;
